import { render, staticRenderFns } from "./standard_list.vue?vue&type=template&id=424a095c&scoped=true&"
import script from "./standard_list.vue?vue&type=script&lang=js&"
export * from "./standard_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a095c",
  null
  
)

export default component.exports